import { useQuery } from "react-query";
import { getVendors } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useVendors = () => {
  const { data, isLoading, refetch } = useQuery("GetVendors", getVendors, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
